module.exports = __webpack_public_path__ + "img/bg_kinerja_keuangan_intro.3d8a9a0a.png";